import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingpune() {



  const cardData =
  {
    keyword: 'Online Cab Booking Pune',
    heading: 'Sanavi Travels: Online Cab Booking Pune',
    headingDescription: 'Sanavi Travels offers reliable Online Cab Booking in Pune, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, tourists, and group commuters within Pune and to nearby destinations. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and convenient ride. With professional chauffeurs, flexible local and outstation cab options, transparent pricing, and 24/7 online booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering key routes and popular destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Aurangabad, Kolhapur, and Konkan. Choose Sanavi Travels for trusted online cab booking in Pune, delivering comfort, safety, and a seamless travel experience at your fingertips.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha heritage. Once the seat of Peshwa Bajirao I, it features grand gateways like the Delhi Darwaza, massive stone walls, and lush gardens. Though partially destroyed by fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum with Gandhi’s artifacts, photographs, and historical documents, set amidst sprawling gardens and serene ambiance."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for extensive charitable work, making it Pune’s spiritual heartbeat."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore ancient ramparts, memorials, and viewpoints. The fort offers breathtaking views of the Sahyadri ranges and local cuisine near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being in the city center, it maintains tranquility and showcases early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal depicts historical lifestyles and makes the museum invaluable for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors seek relaxation, rejuvenation, and personal transformation here."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers provide a serene sanctuary. Families, joggers, and photographers enjoy peaceful walks here."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The reservoir and surrounding hills create picturesque scenery, especially during monsoon. Street vendors add charm, and the dam also serves as the gateway to Sinhagad Fort, making it ideal for weekends and family outings."
  }
]
,




"services": [
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to reserve cabs conveniently from anywhere in Pune. With instant confirmation, professional drivers, and a variety of vehicles, it ensures a hassle-free travel experience for local and outstation trips."
  },
  {
    "name": "Book Cab Online Pune",
    "description": "Book Cab Online Pune provides a seamless platform to book cabs in advance. Travelers can choose AC, luxury, or standard cabs for city travel, airport transfers, or long-distance journeys with ease and reliability."
  },
  {
    "name": "Cab Rental Service Pune",
    "description": "Cab Rental Service Pune offers dependable rental cabs for short and long trips. Well-maintained vehicles, professional chauffeurs, and transparent pricing make it ideal for families, corporate travelers, and tourists."
  },
  {
    "name": "AC Cab Booking Pune",
    "description": "AC Cab Booking Pune provides air-conditioned vehicles for comfortable travel in Pune. Perfect for summer days, long-distance trips, and airport transfers, these cabs ensure a smooth and pleasant journey."
  },
  {
    "name": "Luxury Cab Booking Pune",
    "description": "Luxury Cab Booking Pune offers premium vehicles for travelers seeking comfort and style. Ideal for corporate executives, VIP clients, or special occasions, these cabs provide top-notch amenities and professional drivers."
  },
  {
    "name": "Corporate Cab Booking Pune",
    "description": "Corporate Cab Booking Pune caters to businesses and office staff commuting within Pune or to nearby cities. Reliable, punctual, and comfortable vehicles ensure smooth travel for meetings, events, and corporate outings."
  },
  {
    "name": "Outstation Cab Booking Pune",
    "description": "Outstation Cab Booking Pune offers safe and comfortable vehicles for long-distance travel from Pune to nearby cities and tourist destinations. Experienced drivers and well-maintained cabs make journeys stress-free."
  },
  {
    "name": "Affordable Cab Booking Pune",
    "description": "Affordable Cab Booking Pune provides budget-friendly cabs without compromising on comfort or safety. Ideal for families, friends, and solo travelers seeking reliable and economical travel options."
  },
  {
    "name": "Chauffeur Driven Cab Pune",
    "description": "Chauffeur Driven Cab Pune ensures a hassle-free experience with professional drivers managing all routes and traffic. Passengers can relax and enjoy their journey in comfort and safety."
  },
  {
    "name": "Best Online Cab Pune",
    "description": "Best Online Cab Pune offers top-quality cabs with excellent service, punctuality, and well-maintained vehicles. Perfect for local travel, airport transfers, and long-distance trips from Pune."
  },
  {
    "name": "Pune Taxi Booking Service",
    "description": "Pune Taxi Booking Service provides easy and reliable cab booking for local and outstation travel. With professional drivers and a fleet of well-maintained vehicles, it ensures safe and comfortable journeys."
  },
  {
    "name": "Local Cab Booking Pune",
    "description": "Local Cab Booking Pune offers cabs for city travel, including sightseeing, shopping trips, and office commutes. Efficient, punctual, and comfortable vehicles make city travel convenient."
  },
  {
    "name": "Airport Cab Booking Pune",
    "description": "Airport Cab Booking Pune provides timely pickups and drop-offs at Pune airport. Spacious and comfortable vehicles ensure luggage-friendly and stress-free transfers for all passengers."
  },
  {
    "name": "Tourist Cab Booking Pune",
    "description": "Tourist Cab Booking Pune caters to travelers exploring Pune and nearby attractions. Well-maintained cabs with experienced drivers make sightseeing tours safe, comfortable, and enjoyable."
  },
  {
    "name": "24x7 Cab Service Pune",
    "description": "24x7 Cab Service Pune offers round-the-clock cab availability for emergencies, late-night travel, and early morning trips. Reliable and professional service ensures you can travel anytime without worry."
  }
],
"tableData": [
  ["Online Cab Booking Pune", "Book Cab Online Pune"],
  ["Cab Rental Service Pune", "AC Cab Booking Pune"],
  ["Luxury Cab Booking Pune", "Corporate Cab Booking Pune"],
  ["Outstation Cab Booking Pune", "Affordable Cab Booking Pune"],
  ["Chauffeur Driven Cab Pune", "Best Online Cab Pune"],
  ["Pune Taxi Booking Service", "Local Cab Booking Pune"],
  ["Airport Cab Booking Pune", "Tourist Cab Booking Pune"],
  ["24x7 Cab Service Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Online Cab Booking in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers easy and reliable online cab booking services in Pune, perfect for airport transfers, city rides, outstation travel, and daily commuting."
  },
  {
    "WhyChooseheading": "Convenient and User‑Friendly Booking",
    "WhyChoosedescription": "Book your cab online quickly and effortlessly through our website or mobile app, anytime and from anywhere in Pune."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced cabs for a smooth and enjoyable journey within Pune or beyond."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are professional, courteous, and familiar with Pune routes, ensuring safe and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for online cab bookings, including all taxes and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with online bookings, travel queries, and real‑time updates."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from a variety of cab types including sedans, SUVs, and premium cars to match your travel needs and budget."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  }
]

}

const faqData = [
  {
    question: 'Can I book a cab online in Pune with Sanavi Travels?',
    answer: 'Yes, Sanavi Travels provides convenient online cab booking services in Pune for city, airport, and outstation travel.'
  },
  {
    question: 'How do I book a cab online in Pune?',
    answer: 'You can book a cab online through our website or mobile app by entering your pickup, drop‑off locations, travel date and time.'
  },
  {
    question: 'What types of cabs are available for online booking?',
    answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars suitable for different group sizes and travel needs.'
  },
  {
    question: 'Are drivers provided with the online cab booking?',
    answer: 'Yes, all online cab bookings include experienced and professional drivers.'
  },
  {
    question: 'Is online cab booking available 24x7?',
    answer: 'Yes, online cab booking is available round the clock to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before pickup?',
    answer: 'Yes, all vehicles are cleaned and sanitized before every trip for passenger safety.'
  },
  {
    question: 'Can I cancel or modify my online cab booking?',
    answer: 'Yes, you can cancel or modify your booking subject to our terms and conditions and fare policy.'
  },
  {
    question: 'What payment options are available for online cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during my trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akash More',
    feedback: 'Booked a cab online through Sanavi Travels for my Pune airport transfer. Very easy and convenient process with friendly service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shruti Kulkarni',
    feedback: 'Excellent online cab booking experience! The cab arrived on time and the driver was professional and courteous.',
    rating: 5
  }
];















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Pune - Sanavi Travels",
  "description": "Book cabs online in Pune with Sanavi Travels. AC and luxury cabs for corporate travel, airport transfers, outstation trips, local travel, tourist trips, and 24x7 chauffeur-driven services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Online Cab Booking Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs online in Pune with Sanavi Travels. Ideal for corporate travel, airport transfers, local travel, outstation trips, tourist trips, and 24x7 chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingpune;